import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { RecipesComponent } from '../../recipes/recipes.component';
import { CloseConfirmComponent } from '../../close-confirm/close-confirm.component';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'vex-edit-banner-area',
  templateUrl: './edit-banner-area.component.html',
  styleUrls: ['./edit-banner-area.component.scss',
    '../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../@vex/styles/partials/plugins/quill/_quill.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditBannerAreaComponent implements OnInit {
  form: UntypedFormGroup;
  formLang: any;
  iconFormFlag: any;
  flags = {
    en: 'flag:united-states',
    it: 'flag:italy'
  };
  currentLang: string;
  selectedFile: File | null = null;
  banner;
  environment = environment.baseURL;

  constructor(@Inject(MAT_DIALOG_DATA) private item: any['item'], private fb: UntypedFormBuilder, public translate: TranslateService, public guiService: GuiService, public restService: RestService, private dialogRef: MatDialogRef<RecipesComponent>, public dialog: MatDialog) {
    this.currentLang = translate.currentLang || translate.getDefaultLang();
  }

  ngOnInit(): void {
    this.changeFormLanguage(this.translate.currentLang);
    this.banner = this.item;
    this.form = this.fb.group({
      nome_it: [null, Validators.required],
      nome_en: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      redirectUrl: [null, Validators.required],
      externalUrl:[null],
      langReference:[null, Validators.required],
      index: [null],
      desc_it: [null, Validators.required],
      desc_en: [null, Validators.required],
      image: null
    })

    this.form.controls['langReference'].setValue(this.item.langReference);
    this.form.controls['nome_it'].setValue(this.item.i18nTitle['it']);
    this.form.controls['nome_en'].setValue(this.item.i18nTitle['en']);
    this.form.controls['desc_it'].setValue(this.item.i18nDescription['it']);
    this.form.controls['desc_en'].setValue(this.item.i18nDescription['en']);
    this.form.controls['startDate'].setValue(this.item.startDate);
    this.form.controls['endDate'].setValue(this.item.endDate);
    this.form.controls['redirectUrl'].setValue(this.item?.redirectUrl);
    this.form.controls['externalUrl'].setValue(this.item?.externalUrl);
    this.form.controls['index'].setValue(this.item?.index);
  }

  changeFormLanguage(lang) {
    this.iconFormFlag = this.flags[lang];
    this.formLang = lang;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
      this.form.patchValue({
        image: this.selectedFile
      });
    }
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

    submit() {
    const formData = new FormData();

    const i18nTitle = {
      it: this.form.get('nome_it')?.value,
      en: this.form.get('nome_en')?.value
    };
    const i18nDescription = {
      it: this.form.get('desc_it')?.value,
      en: this.form.get('desc_en')?.value
    };

    formData.append('langReference', this.form.get('langReference')?.value);
    formData.append('i18nTitle', JSON.stringify(i18nTitle));
    formData.append('i18nDescription', JSON.stringify(i18nDescription));
    formData.append('index', this.form.get('index')?.value);
    formData.append('redirectUrl', this.form.get('redirectUrl')?.value);
    formData.append('externalUrl', this.form.get('externalUrl')?.value);
    formData.append('startDate', moment(this.form.get('startDate')?.value).format('YYYY-MM-DD'));
    formData.append('endDate', moment(this.form.get('endDate')?.value).format('YYYY-MM-DD'));
    formData.append('bannerId', this.banner._id);

    if (this.selectedFile) {
      formData.append('image', this.selectedFile, this.selectedFile.name);
    }

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postServiceUserId('node', '/update-banner', formData, this.guiService.userLogged.user.id).subscribe((ris) => {
      this.dialogRef.close('done');
    })
  }

}
